import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Outlet, useLocation, useNavigation } from 'react-router-dom';
import { Answer } from '@ripe/webtoolkit/lib/juiceWebApi/types/answer';
import Footer from './Footer';

const mentionMeUrl = window.location.hostname.indexOf('local') === -1 && window.location.hostname.indexOf('develop') === -1 && window.location.hostname.indexOf('uat') === -1 ? 'https://tag.mention-me.com/api/v2/refereefind/mmb6015fbe?situation=checkout&locale=en_GB' : 'https://tag-demo.mention-me.com/api/v2/refereefind/mmb6015fbe?situation=checkout&locale=en_GB';

export default function App() {
  const navigation = useNavigation();
  const location = useLocation();

  const [loadMentionMeScript, setLoadMentionMeScript] = useState(false);
  const [formInstance, setFormInstance] = useState<HTMLElement | null>(null);

  useEffect(() => {
    if (navigation.state && navigation.state === 'idle') {
      window.VWO = window.VWO || [];
      const formInstance = document.getElementById(location.pathname.replace('/', ''));
      setFormInstance(formInstance);

      if (window.MentionMeFiredTags != undefined && window.MentionMeFiredTags != '') {
        const situation = 'checkout';
        const implementation = 'link';

        if (window.MentionMeFiredTags[implementation + situation] == true) {
          delete window.MentionMeFiredTags[implementation + situation];
        }
      }

      if (location.pathname.indexOf('business-details') !== -1) {
        setLoadMentionMeScript(true);
      } else {
        setLoadMentionMeScript(false);
      }

      if (location.pathname.indexOf('quote-summary') !== -1) {
        const dataLayerPushed = sessionStorage.getItem('dataLayerPushed');
        if (!dataLayerPushed) {
          const storedData = JSON.parse(sessionStorage.getItem('octopus-data') || '{}') as { answers?: Answer[] };
          const organizationTypeQuestionId = '382f07f8-edc7-4f3a-8217-de0308cd15bd';
          const organizationType = (storedData.answers || []).find((answer: Answer) => answer.questionId === organizationTypeQuestionId)?.value as string;

          let sportTypes: string[] = [];
          if (organizationType === 'Sports Club') {
            const sportTypeQuestionId = '9b930473-b21d-4517-9f24-de0be10d39ec';
            sportTypes = ((storedData.answers || []).filter((answer: Answer) => answer.questionId === sportTypeQuestionId) as Answer[]).map((a) => a.value as string);
          }
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'quote',
            policyType: organizationType?.replaceAll(' ', ''),
            tradeType: sportTypes.join(', '),
          });
          // Set the flag in session storage to indicate that the code has run
          sessionStorage.setItem('dataLayerPushed', 'true');
        }
      }
    }

    if (navigation.state && navigation.state !== 'idle') {
      window.VWO.push(['nls.formAnalysis.markSuccess', formInstance, 1]);
    }
  }, [navigation.state, location]);

  return (
    <>
      {loadMentionMeScript && (
        <Helmet>
          <script type="text/javascript" src={mentionMeUrl} crossOrigin="anonymous" async />
        </Helmet>
      )}
      <div className="sclc-bg-white sclc-pt-[8px] sclc-flex sclc-flex-col sclc-justify-center sclc-relative">
        <div className="sclc-w-full sclc-px-6 sclc-pb-6 sclc-bg-white md:sclc-max-w-3xl md:sclc-mx-auto lg:sclc-max-w-5xl lg:sclc-pt-4">
          <Outlet />
        </div>
      </div>
      <Footer />
    </>
  );
}
